const MOVES = ["ArrowDown", "ArrowUp", "Home", "End"];
const PICKS = ["Enter", " "];

export function listboxAction(key, open) {
  if (!open) return MOVES.slice(0, 2).includes(key) || PICKS.includes(key) ? "open" : null;
  if (MOVES.includes(key)) return "move";
  if (PICKS.includes(key)) return "pick";
  if (key === "Escape") return "close";
  if (key === "Tab") return "leave";
  return null;
}

export function listboxIndex(index, key, count) {
  if (count <= 0) return -1;
  if (key === "Home") return 0;
  if (key === "End") return count - 1;
  if (key === "ArrowDown") return index < 0 ? 0 : Math.min(index + 1, count - 1);
  if (key === "ArrowUp") return index < 0 ? count - 1 : Math.max(index - 1, 0);
  return index;
}

export function selectedIndex(options) {
  return options.findIndex((option) => option.getAttribute("aria-selected") === "true");
}

export function enterIndex(active, count) {
  if (active >= 0) return active;
  return count === 1 ? 0 : -1;
}

export function matchesQuery(text, query) {
  const needle = query.trim().toLowerCase();
  return !needle || text.toLowerCase().includes(needle);
}

export function searchStatus(count, noun) {
  if (count === 0) return `No ${noun}s match`;
  return `${count} ${noun}${count === 1 ? "" : "s"}`;
}
